import { formatUnits } from "viem";

/**
 * Format a token balance (BigInt) into a human-readable string
 * @param {bigint|string} balance - raw balance from contract
 * @param {number} decimals - token decimals (e.g. 18 for ERC20)
 * @param {boolean} compact - whether to show compact notation (K, M, B)
 * @returns {{display: string, full: string}}
 */
 function formatBalance(balance, decimals = 18, compact = false) {
  if (!balance) return 0;

  // Convert BigInt to decimal string
  const formatted = formatUnits(balance, decimals);



  // Convert to number for display formatting
  const num = Number(formatted);

  if (num === 0) {
    return "0"
  }

  // Pretty format
  const display = num?.toLocaleString(undefined, {
    notation: compact ? "compact" : "standard",
    maximumFractionDigits: 4,
  });

  return display;

}


export default formatBalance;